import type { AxiosInstance } from 'axios';
import type {
	NahledyudajuIsssVyuzitiAisSeznamDto,
	NahledyudajuIsssVyuzitiStahniPdfSeznamuVyuzivaniIsssParams,
	NahledyudajuIsssVyuzitiVypisSeznamAisParams,
	NahledyudajuIsssVyuzitiVypisSeznamVyuzivaniIsssParams,
	NahledyudajuIsssVyuzitiVyuzitiIsssListDto,
} from '../generated';

export const isssDownloadQuery = async ({
	axiosInstance,
	...params
}: NahledyudajuIsssVyuzitiStahniPdfSeznamuVyuzivaniIsssParams & {
	axiosInstance: AxiosInstance;
}) =>
	await axiosInstance.get<Blob>('/api/v1/isss/vyuziti/stahnout', {
		responseType: 'blob',
		params,
	});

export const isssUsageQuery = async (
	axiosInstance: AxiosInstance,
	params: NahledyudajuIsssVyuzitiVypisSeznamVyuzivaniIsssParams
) =>
	await axiosInstance.get<NahledyudajuIsssVyuzitiVyuzitiIsssListDto>(
		'/api/v1/isss/vyuziti',
		{
			params,
		}
	);

export const isssUsageAisQuery = async (
	axiosInstance: AxiosInstance,
	params: NahledyudajuIsssVyuzitiVypisSeznamAisParams
) =>
	await axiosInstance.get<NahledyudajuIsssVyuzitiAisSeznamDto>(
		'/api/v1/isss/vyuziti/ais',
		{ params }
	);
